// eslint-disable-next-line import/prefer-default-export
export function onDropdownClose(dropdown) {
  $(dropdown).find('.selected').not('.active').removeClass('selected');
}
